import React, { Component, useMemo } from "react";
import { clarity } from "react-microsoft-clarity";
import { useDispatch, connect } from "react-redux";
import { Route, Switch, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

import { actionCreators as homeActionCreators } from "./common/header/store";
import { actionCreators as actionCreatorsAccount } from "./pages/manageaccount/store";
import { actionCreators as actionCreatorsConfig } from "./common/config/store";
import API from "./server";
import { RedirectWithQuery } from "./common/linkWithQuery";
import Header from "./common/header";
import routes from "./routes";
import profile from "./utils/profile";

const Error404 = React.lazy(() => import("./pages/errorPage/404"));

function checkAuth(route, props) {
  if (route.auth) {
    const authRoute = route.auth(profile, props);
    if (authRoute instanceof Promise) {
      authRoute.then((res) => {
        if (!res) {
          window.location = "/access-denied";
        }
      });
    }
    if (!authRoute) {
      window.location = "/access-denied";
    }
  }
}

function RenderRoute({ route, props, accountId }) {
  const dispatch = useDispatch();
  const preAccId = accountId;
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const accId = searchParams.get("account_id");
  const routeComponent = <route.component {...props} {...route.props} />;
  let component = <></>;
  if (accId && accId !== preAccId && accId !== "undefined" && accId !== "") {
    localStorage.setItem("paylab_account_id", accId);
    localStorage.setItem("subscriptionNoticeClosed", false);
    dispatch(homeActionCreators.login()).then((_) => {
      component = routeComponent;
    });
  } else {
    component = routeComponent;
  }
  checkAuth(route, props);
  return component;
}

class MainPage extends Component {
  componentDidMount() {
    API.login_info()
      .then((res) => res?.data)
      .then((res) => {
        this.props.login(res.data.profile);
      })
      .then(() =>
        API.read_config()
          .then((res) => res.data)
          .then((res) => {
            this.props.setConfig(res.data.config);
            if (!res.data.config.mapbox_token) {
              localStorage.removeItem("MAPBOX_TOKEN");
            } else {
              localStorage.setItem(
                "MAPBOX_TOKEN",
                res.data.config.mapbox_token,
              );
            }
            // Initialise Microsoft Clarity
            if (res?.data?.config?.microsoft_clarity_token) {
              clarity.init(res.data.config.microsoft_clarity_token);
            }
            let measurementId = res.data.config.ga_tracking_id;
            if (measurementId) {
              ReactGA.initialize(measurementId);
            }
            if (res?.data?.config?.hubspot_request_support_portal_id) {
              sessionStorage.setItem(
                "hubspot_request_support_portal_id",
                res.data.config.hubspot_request_support_portal_id,
              );
            }

            if (res?.data?.config?.hubspot_request_support_form_id) {
              sessionStorage.setItem(
                "hubspot_request_support_form_id",
                res.data.config.hubspot_request_support_form_id,
              );
            }

            sessionStorage.setItem("integrationErrorClosed", false);
            sessionStorage.setItem("integrationErrorVisited", false);
          }),
      );
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.props.checkXeroConnection();
    }
  }
  render() {
    const { accountId } = this.props;
    return (
      <>
        {this.props.isLoggedIn && (
          <Switch>
            <Route
              path="/"
              exact
              render={() => <RedirectWithQuery to="/dashboard" />}
            />
            {routes.map((route) => {
              return (
                <Route
                  exact
                  key={route.path}
                  path={route.path}
                  render={(props) =>
                    route.navText ? (
                      <React.Fragment>
                        <Header />
                        <RenderRoute
                          route={route}
                          props={props}
                          accountId={accountId}
                        />
                      </React.Fragment>
                    ) : (
                      <RenderRoute route={route} />
                    )
                  }
                />
              );
            })}
            <Route component={Error404} />
          </Switch>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.getIn(["headers", "isLoggedIn"]),
    accountId: state.getIn(["headers", "profile", "payclaim_account_id"]),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    login(data) {
      dispatch(homeActionCreators.login(data));
    },
    setConfig(config) {
      dispatch(homeActionCreators.setData("config", config));
      dispatch(actionCreatorsAccount.getAccountInfo());
      dispatch(actionCreatorsConfig.getAccountConfig());
      dispatch(actionCreatorsConfig.readCountries());
    },
    checkXeroConnection() {
      dispatch(actionCreatorsAccount.checkXeroConnection());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
